if(!customElements.get('video-card')) {
  customElements.define(
    'video-card',
    class VideoCard extends HTMLElement {
      #video = undefined;

      connectedCallback() {
        this.#video = this.querySelector('video');
      }

      play() {
        this.#video.play();
      }

      stop() {
        this.#video.pause();
      }
    }
  )
}